import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import clsx from 'clsx';

import { Element } from '@shared/interfaces/element.interface';
import { ExchangeCurrencyResult, useExchangeCurrency } from '@shared/hooks/useExchangeCurrency';

import { useLanguage } from '@hooks/useLanguage';
import { Currency } from '@shared/enums';
import { mapLanguageToCurrency } from '@shared/utils/currencies';

interface ButtonAmountProps extends Element {
  amount: number;
  count: number;
  active?: boolean;
  onClick?: (amount: number) => void;
}

function formatCurrencyValue(exchanged: ExchangeCurrencyResult, t: (value: string) => string) {
  const value = exchanged.to === Currency.Uah ? exchanged.value.toString() : `${exchanged.value}`;

  return `${value} ${t(exchanged.to.toLowerCase())}`;
}

export const AmountButton: React.FC<ButtonAmountProps> = ({ amount, count, active = false, onClick }) => {
  const { t } = useTranslation();
  const language = useLanguage();
  const exchangeCurrency = useExchangeCurrency();

  const toCurrency = mapLanguageToCurrency(language);
  const exchanged = useMemo(() => exchangeCurrency(amount, { to: toCurrency }), [amount, toCurrency, exchangeCurrency]);

  function onAmountClick() {
    if (onClick) onClick(amount);
  }

  return (
    <button
      className={clsx(
        'min-w-[6.5rem] max-w-[10rem] grow h-[3rem] text-xs text-black font-bold bg-black-7 rounded-2xl transition-colors',
        active && '!text-white !bg-black',
      )}
      onClick={onAmountClick}
    >
      {formatCurrencyValue(exchanged, t)} {count > 1 ? ` (${count} ${t('pc')})` : ''}
    </button>
  );
};
